import axios from 'axios';
import store from './store';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import cookies from 'browser-cookies';

// Constants
import { ENV } from '../constants/app';
import { BASE_URL_V1 } from '../constants/endpoints';
import { ERROR_CODE_USERS, ERROR_CODE_PAYMENTS, ERROR_CODE_COUPON } from '../constants/errorCodes';

// Helpers
import { isPublicRoute } from '../libs/helpers';
import * as Sentry from '@sentry/browser';

// Redux
import { purgeAccountData, clearToken } from '../redux/actions/accountActions';
import { clearAdmin } from '../redux/actions/adminActions';
import { showNormalNotification } from '../redux/actions/notificationsActions';

const isDevelopment = BASE_URL_V1.includes('dev'), // NOTE: Patch, se requiere entender el problema real de la variable de entorno ENV
  path = window.location.pathname;

const not = params => {
  if (!isUndefined(params)) {
    return store.dispatch(showNormalNotification({ ...params }));
  }
}; // END not

/* ##############
### Request
############## */
const configModifiers = config => {
  const { access_token } = get(store.getState(), 'account');
  const { user_token } = get(store.getState(), 'account');
  const { headers, url, method } = config;

  if (access_token && headers) config.headers['Authorization'] = `Bearer ${verifyTokens({ access_token, user_token })}`;

  if (
    url.includes('/v2/companies') ||
    url.includes('/v2/auth/companies') ||
    url.includes('v1/account/generateOTP') ||
    url.includes('v1/account/confirmOTP') ||
    url.includes('v1/account/me')
  )
    config.headers['Authorization'] = `Bearer ${user_token}`;

  if (url.includes('v1/account/me/verification') || url.includes('v1/account/me/password/change')) config.headers['Authorization'] = `Bearer ${access_token}`;

  if (
    (url.includes('/v2/companies') && method === 'post') ||
    url.includes('/v2/companies/group-report') ||
    url.includes('/v2/companies/request-report')
  )
    config.headers['Authorization'] = `Bearer ${verifyTokens({ access_token, user_token })}`;

  // if (USE_STG) return config;

  // if (localhost === null && browserUrl.indexOf('localhost:3000') !== -1) {
  //   config.url = config.url.replace(/https:\/\/dev.api.porcobrar.com/g, 'http:\/\/localhost:2018');

  // } else if (!localhost && browserUrl.indexOf('localhost:3000') !== -1) {
  //   console.warn(`Localhost is working with staging API: ${config.url}`);

  // } else if (localhost && browserUrl.indexOf('localhost:3000') !== -1) {
  //   config.url = config.url.replace(/https:\/\/dev.api.porcobrar.com/g, 'http:\/\/localhost:2018');

  // } // END if -- in localhost

  // if (!!localhost && browserUrl.indexOf('stage.app.porcobrar.com') !== -1) {
  //   console.warn(`Staging app is working with localhost API on port 2018 ${config.url}`);
  //   config.url = config.url.replace(/https:\/\/dev.api.porcobrar.com/g, 'http:\/\/localhost:2018');

  // } // END if

  return config;
}; // END configModifiers

const verifyTokens = ({ access_token, user_token }) => {
  if (access_token === null) return user_token;

  return access_token;
};

/* Request */
const configErrorModifiers = error => {
  return Promise.reject(error);
}; // END configErrorModifiers

axios.interceptors.request.use(configModifiers, configErrorModifiers); // END request.use

/* ##############
### Response
############## */
const responseErrorModifier = error => {
  try {
    const excludeUrls = ['/v1/educational-addendum'];
    
    const url = get(error, 'config.url');
    const isExcluded = excludeUrls.some(excludeUrl => url.includes(excludeUrl));
    if (isExcluded) return;

    const code = get(error, 'response.status', get(error, 'message'));
    const codeMessage = get(error, 'response.data.message', 'No disponible');
    const appCode = get(error, 'response.data.code');
    const isInstanceOfError = error && get(error, 'stack') && get(error, 'message');
    if (code === 404) {
      not({ color: 'warning', message: 'Recurso no encontrado, 404.' });
      // return navigateTo({ to: '/app/dashboard' })
    } else if (code === 500) {
      not({ color: 'danger', message: 'Algo salio mal, intenta más tarde.' });
    } else if (code === 400 & codeMessage === 'Name is duplicated') {
      not({ color: 'warning', message: 'El nombre ya existe' });
    } else if (code === 400 & codeMessage === 'DUPLICATED_NAME') {
      not({ color: 'warning', message: 'El nombre de sucursal ya existe' });
    } else if (code === 400) {
      if (appCode === 711000) {
        not({ color: 'danger', message: 'Error con el servicio SPEI' });
      } else if (appCode === 711001) {
        not({ color: 'danger', message: 'Servicio no disponible, intenta mas tarde' });
      } else if (appCode === 712504) {
        not({ color: 'warning', message: 'Se encuentra sincronizando' });
      }


      not(ERROR_CODE_USERS[appCode]);
      not(ERROR_CODE_PAYMENTS[appCode]);
      not(ERROR_CODE_COUPON[appCode]);
    } else if (code === 402) {
      if (appCode === 128) {
        not({ color: 'danger', message: 'Ya no cuentas con descargas, adquiere un paquete' });
      }//END if
    } else if (code === 401) {
      if (isPublicRoute()) {
        not({
          color: 'warning',
          message: 'Petición fallida, no tienes autorización para solicitar este recurso.',
          duration: 5,
          unique: true
        });
      } else {
        const { status } = get(store.getState(), 'admin', {});

        if (status === 'active') store.dispatch(clearAdmin());

        cookies.set('prevpath', path);
        not({ color: 'warning', message: 'Tu sesión caducó.', duration: 5, unique: true });
        store.dispatch(purgeAccountData());
        store.dispatch(clearToken({ redirect: '/' }));
        // originalRequest._retry = true;
        //
        // store.dispatch({ type:REFRESH_TOKEN }).then(response => {
        //   let
        //     token      = response.data.token,
        //     headerAuth = 'Bearer ' + response.data.token;
        //
        //   store.dispatch(SET_TOKEN, token);
        //   axios.defaults.headers['Authorization'] = headerAuth;
        //   originalRequest.headers['Authorization'] = headerAuth;
        //
        //   return axios(originalRequest);
        //
        // }).catch(error => store.dispatch(LOG_OUT)) // END
      } // END if
    } else if (code === 403) {
      if (appCode === 105) {
        return;
      } else if (appCode === 125) {
        not({ color: 'warning', message: 'No tienes autorización para realizar este cambio' });
      } else {
        not({ color: 'danger', message: 'No tienes autorización sobre este recurso.', duration: 5, unique: true });
      } // END if
    } else if (code === 409) {
      if (appCode === 107 && codeMessage.includes('legal_name')) {
        not({ color: 'danger', message: 'La razón social ya se encuentra registrada.', duration: 10 });
      } else if (appCode === 107) {
        not({ color: 'danger', message: 'El RFC ya se encuentra registrado.' });
      } else if (appCode === 116) {
        not({ color: 'danger', message: 'Se requiere certificado de sello digital.' });
      } else if (appCode === 119) {
        not({ color: 'danger', message: 'Elimina primero los pagos correspondientes.' });
      } else if (appCode === 127) {
        not({ color: 'warning', message: 'Agrega un método de pago.' });
        return Promise.reject(error);
      } else if (appCode === 200124) {
        console.error(`${code}`);
      } else if (codeMessage === 'Duplicated destination email') {
        not({ color: 'warning', message: 'No se puede enviar el recordatorio. Hay correos duplicados en el destinatario.' });
      } else {
        not({ color: 'danger', message: 'El recurso ya fue creado con anterioridad.', duration: 5, unique: true });
      } // END if
    } else if (code === 'Network Error') {
      not({ color: 'danger', message: 'Revisa tu conexión o intenta más tarde.' });
    }

    // NOTE: Patch, debug log para ver el valor de la variable de entorno ENV
    console.debug(`Environment: ${ENV}`);

    if (isDevelopment) {
      const debugMessage = get(error, 'response.data.message', get(error, 'message'));
      if (appCode !== 103) {
        not({ className: 'right-bottom', message: `${code} > ${debugMessage}`, duration: 10 });
      }
    } // END if

    if (isInstanceOfError) {
      Sentry.captureException(error);
    }
  } catch (e) {
    throw e;
  } // END try

  return Promise.reject(error);
}; // END responseErrorModifier

const responseModifier = response => {
  const httpMethod = response.config.method;
  const httpCode = response.status;
  const is200 = httpCode >= 200 || httpCode <= 300;

  const url = response.config.url;
  const excludeUlrs = [
    'v1/auth',
    'v1/team/attribute/1',
    'v1/team/attribute/2',
    'v1/pay_request/invoice',
    'v1/invoice/import/xml',
    'v1/import/invoice',
    'v1/import/customer',
    '/invoice/quick_collection',
    'v2/auth/companies',
    'v1/account/confirmOTP',
    '/v1/account/user',
    '/v2/auth',
    '/v1/account/generateOTP',
    '/v2/companies',
    '/v2/integrations/accountants/sap',
    '/generate-cfdi',
    'v2/integrations/payments/spei',
    '/import/contract',
    '/import-bulk-payments',
    '/pay_order/spei',
    '/pay_request/invoice',
    '/pay_request/check',
    '/bank-reconciliation/session-token',
    '/bank-reconciliation',
    '/payment-reconciliation',
    '/checkout-events',
    '/v1/assistant',
  ];
  const res = excludeUlrs.filter(cur => (url.indexOf(cur) !== -1 ? cur : false));

  if (res.length === 0) {
    // ::TODO:: Fix defualt notificacions
    if (httpMethod === 'post' && is200) {
      if (url.endsWith('hfdkhfdkhfdkkdsjhkdshk/collection')) {
        not({
          color: 'success',
          message: `Se ha enviado la prueba correctamente`,
          duration: 2
        });
      } else if (url.endsWith('password/change')) {
        not({
          color: 'success',
          message: `Se actualizó la contraseña correctamente`,
          duration: 2
        });
      } else if (url.endsWith('password/recovery')) {
        not({
          color: 'success',
          // message: `Se ha enviado el correo exitosamente`,
          message: `Se enviará un correo de confirmación a tu cuenta de correo`,
          duration: 2
        });
      } else if (url.endsWith('account/invitation')) {
        not({
          color: 'success',
          message: `La invitación se ha enviado`,
          duration: 2
        });
      } else if (url.endsWith('notification?limit=100')) {
        return;
      } else if (url.endsWith('subscriptions/support')) {
        return;
      }else if (url.includes('early_payment')) {
        not({
          color: 'success',
          message: `Descuento por pronto pago creado correctamente.`,
          duration: 3
        });
      }  else {
        if (!url.includes('integration/7')) {
          not({
            color: 'success',
            message: `Se ha realizado el registro correctamentes`,
            duration: 3
          });
        }
      }
    } else if (httpMethod === 'put' && is200) {
      if (url.endsWith('/team/notification')) {
        return;
      } else if (url.includes('account/user')) {
        not({
          color: 'success',
          message: `El usuario se ha modificado.`,
          duration: 2
        });
      }else if (url.includes('early_payment')) {
        not({
          color: 'success',
          message: `Descuento por pronto pago editado correctamente.`,
          duration: 3
        });
      } 
      else if (url.includes('source-payments')) {
        not({
          color: 'success',
          message: `Tipo de pago editado correctamente.`,
          duration: 3
        });
      } 
      // else {
      //   not({
      //     color: 'success',
      //     message: `La información se ha actualizado correctamente`,
      //     duration: 2 })
      //   }
    } else if (httpMethod === 'delete' && is200) {
      if (url.includes('tax')) {
        return;
      } else if (url.includes('account/invitation')) {
        not({
          color: 'success',
          message: `La invitación se ha eliminado.`,
          duration: 2
        });
      } else if (url.includes('account/user')) {
        not({
          color: 'success',
          message: `El usuario se ha eliminado.`,
          duration: 2
        });
      }
      else if (url.includes('early_payment')) {
        not({
          color: 'success',
          message: `Descuento por pronto pago eliminado correctamente.`,
          duration: 3
        });
      }  else {
        not({
          color: 'success',
          message: `La información se ha eliminado.`,
          duration: 2
        });
      }
    }
  } // END if

  return response;
}; // END responseModifier

axios.interceptors.response.use(responseModifier, responseErrorModifier); // END response.use

/* ::TODO::  Evaluate caching
function loadCached(url) {
  let cache = loadCached.cache || (loadCached.cache = new Map());

  if (cache.has(url)) {
    return Promise.resolve(cache.get(url)); // (*)
  }

  return fetch(url)
    .then(response => response.text())
    .then(text => {
      cache.set(url,texisProductiont);
      return text;
    });
} */



// WEBPACK FOOTER //
// ./src/app/intercept.js